import sigma1 from 'assets/images/projects/6Sigma/6Sigma_MetaisBasicos.jpg'
import sigma2 from 'assets/images/projects/6Sigma/6Sigma_CorredorNorte.jpg'
import sigma3 from 'assets/images/projects/6Sigma/6Sigma_Pelotizacao.jpeg'
import ccq1 from 'assets/images/projects/CCQ/CCQ_PTVI.jpg'
import ccq2 from 'assets/images/projects/CCQ/CCQ_Carvao_Saneamento.jpg'
import ccq3 from 'assets/images/projects/CCQ/CCQ_MetaisBasicos.png'
import ccq4 from 'assets/images/projects/CCQ/CCQ_CorredorSudeste.jpg'
import ccq5 from 'assets/images/projects/CCQ/CCQ-05.jpg'
import ccq6 from 'assets/images/projects/CCQ/CCQ_CorredorSul.png'
import ccq7 from 'assets/images/projects/CCQ/CCQ_CorredorNorte.png'
import especialistas1 from 'assets/images/projects/Especialistas/Especialistas_Anymal.png'
import especialistas2 from 'assets/images/projects/Especialistas/Imagem2.png'
import especialistas3 from 'assets/images/projects/Especialistas/locomotiva.png'
import especialistas4 from 'assets/images/projects/Especialistas/Especialistas_ReduceRiskOfLOC.png'
import especialistas5 from 'assets/images/projects/Especialistas/Especialistas_Neutrons_Pulsados.jpg'
import especialistas6 from 'assets/images/projects/Especialistas/Especialistas_Corveador.jpg'
import especialistas7 from 'assets/images/projects/Especialistas/drone.jpg'
import especialistas8 from 'assets/images/projects/Especialistas/Especialistas_PreventFormationOfLiquid_BabakShobeir.png'
import especialistas9 from 'assets/images/projects/Especialistas/especialistas-9.jpeg'
import especialistas10 from 'assets/images/projects/Especialistas/queimador-de-plasma.png'
import especialistas11 from 'assets/images/projects/Especialistas/Especialistas_Contct_Tracing_Bandage.png'
import kaizen1 from 'assets/images/projects/Kaizen/Kaizen_PTVI_Electric.jpg'
import kaizen2 from 'assets/images/projects/Kaizen/Kaizen_Carvao.jpg'
import kaizen3 from 'assets/images/projects/Kaizen/Kaizen_Corp_SIC.png'
import kaizen4 from 'assets/images/projects/Kaizen/Kaizen_Corp_Programa.png'
import kaizen5 from 'assets/images/projects/Kaizen/Kaizen_Corp_Centralizacao.jpg'
import kaizen6 from 'assets/images/projects/Kaizen/Kaizen_MetaisBasicosAN.jpg'
import kaizen7 from 'assets/images/projects/Kaizen/Kaizen_CorredorSul_Acesso.png'
import kaizen8 from 'assets/images/projects/Kaizen/Kaizen_CorredorSudeste_Eliminando.png'
import kaizen9 from 'assets/images/projects/Kaizen/Kaizen_Corredor_Norte_Monitoramento.png'
import kaizen10 from 'assets/images/projects/Kaizen/Kaizen_MetaisBasicosAS_Mitigacao.jpg'
import kaizen11 from 'assets/images/projects/Kaizen/KAIZEN_01.jpg'
import kaizen12 from 'assets/images/projects/Kaizen/Kaizen_MetaisBasicosAN_Production.jpg'

export const projects = [
  {
    key: 'projects.project-1.title',
    text: [
      {
        textTitle: 'projects.project-1.title',
        textDescription: 'projects.project-1.description',
      },
    ],
    items: [
      [
        {
          url: sigma1,
          title: 'projects.project-1.items.item-1.title',
          description: '',
        },
        {
          url: sigma2,
          title: 'projects.project-1.items.item-2.title',
          description: '',
        },
        {
          url: sigma3,
          title: 'projects.project-1.items.item-3.title',
          description: '',
        },
      ],
    ],
  },
  {
    key: 'projects.project-2.title',
    text: [
      {
        textTitle: 'projects.project-2.title',
        textDescription: 'projects.project-2.description',
      },
    ],
    items: [
      [
        {
          url: ccq1,
          title: 'projects.project-2.items.item-1.title',
          description: '',
        },
        {
          url: ccq2,
          title: 'projects.project-2.items.item-2.title',
          description: '',
        },
        {
          url: ccq3,
          title: 'projects.project-2.items.item-3.title',
          description: '',
        },
        {
          url: ccq4,
          title: 'projects.project-2.items.item-4.title',
          description: '',
        },
        {
          url: ccq5,
          title: 'projects.project-2.items.item-5.title',
          description: '',
        },
        {
          url: ccq6,
          title: 'projects.project-2.items.item-6.title',
          description: '',
        },
      ],
      [
        {
          url: ccq7,
          title: 'projects.project-2.items.item-7.title',
          description: '',
        },
      ],
    ],
  },
  {
    key: 'projects.project-3.title',
    text: [
      {
        textTitle: 'projects.project-3.title',
        textDescription: 'projects.project-3.description',
      },
    ],
    items: [
      [
        {
          url: especialistas1,
          title: 'projects.project-3.items.item-1.title',
          description: '',
        },
        {
          url: especialistas2,
          title: 'projects.project-3.items.item-2.title',
          description: '',
        },
        {
          url: especialistas3,
          title: 'projects.project-3.items.item-3.title',
          description: '',
        },
        {
          url: especialistas4,
          title: 'projects.project-3.items.item-4.title',
          description: '',
        },
        {
          url: especialistas5,
          title: 'projects.project-3.items.item-5.title',
          description: '',
        },
        {
          url: especialistas6,
          title: 'projects.project-3.items.item-6.title',
          description: '',
        },
      ],
      [
        {
          url: especialistas7,
          title: 'projects.project-3.items.item-7.title',
          description: '',
        },
        {
          url: especialistas8,
          title: 'projects.project-3.items.item-8.title',
          description: '',
        },
        {
          url: especialistas9,
          title: 'projects.project-3.items.item-9.title',
          description: '',
        },
        {
          url: especialistas10,
          title: 'projects.project-3.items.item-10.title',
          description: '',
        },
        {
          url: especialistas11,
          title: 'projects.project-3.items.item-11.title',
          description: '',
        },
      ],
    ],
  },
  {
    key: 'projects.project-4.title',
    text: [
      {
        textTitle: 'projects.project-4.title',
        textDescription: 'projects.project-4.description',
      },
    ],
    items: [
      [
        {
          url: kaizen1,
          title: 'projects.project-4.items.item-1.title',
          description: '',
        },
        {
          url: kaizen2,
          title: 'projects.project-4.items.item-2.title',
          description: '',
        },
        {
          url: kaizen3,
          title: 'projects.project-4.items.item-3.title',
          description: '',
        },
        {
          url: kaizen4,
          title: 'projects.project-4.items.item-4.title',
          description: '',
        },
        {
          url: kaizen5,
          title: 'projects.project-4.items.item-5.title',
          description: '',
        },
        {
          url: kaizen6,
          title: 'projects.project-4.items.item-6.title',
          description: '',
        },
      ],
      [
        {
          url: kaizen7,
          title: 'projects.project-4.items.item-7.title',
          description: '',
        },
        {
          url: kaizen8,
          title: 'projects.project-4.items.item-8.title',
          description: '',
        },
        {
          url: kaizen9,
          title: 'projects.project-4.items.item-9.title',
          description: '',
        },
        {
          url: kaizen10,
          title: 'projects.project-4.items.item-10.title',
          description: '',
        },
        {
          url: kaizen11,
          title: 'projects.project-4.items.item-11.title',
          description: '',
        },
        {
          url: kaizen12,
          title: 'projects.project-4.items.item-12.title',
          description: '',
        },
      ],
    ],
  },
]
